var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20H15.4444V16.4699C15.4438 15.9211 15.2013 15.3949 14.7701 15.0069C14.339 14.6188 13.7543 14.4006 13.1446 14.4H6.85544C6.24567 14.4006 5.66104 14.6188 5.22986 15.0069C4.79868 15.3949 4.55617 15.9211 4.55556 16.4699V20H3V16.4699C3.00123 15.55 3.40783 14.668 4.1306 14.0175C4.85337 13.367 5.8333 13.0011 6.85544 13H13.1446C14.1667 13.0011 15.1466 13.367 15.8694 14.0175C16.5922 14.668 16.9988 15.55 17 16.4699V20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12C9.0111 12 8.0444 11.7068 7.22215 11.1573C6.3999 10.6079 5.75904 9.82705 5.3806 8.91342C5.12811 8.30385 5 7.65345 5 7H6.66667C6.66667 7.2173 6.68791 7.43511 6.73072 7.6503C6.85934 8.2969 7.1768 8.89085 7.64298 9.35702C8.10915 9.8232 8.7031 10.1407 9.3497 10.2693C9.9963 10.3979 10.6665 10.3319 11.2756 10.0796C11.8847 9.82731 12.4053 9.40006 12.7716 8.8519C13.1378 8.30374 13.3333 7.65927 13.3333 7H15C14.9987 8.32568 14.4715 9.59668 13.5341 10.5341C12.5967 11.4715 11.3257 11.9987 10 12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46154 4.80822L7.69231 1.52055C9.15385 0.826484 10.8462 0.826484 12.3077 1.52055L11.5385 4.80822M12.1923 2.10502C13.4231 2.79909 14.2308 4.07763 14.2308 5.53881V6.26941L15 7H5L5.76923 6.26941V5.53881C5.76923 4.07763 6.57692 2.79909 7.80769 2.10502",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.b2a639ab.svg";
export { ForwardRef as ReactComponent };